<template>
    <HeaderNavs :loading="loading" :data="data" />
</template>

<script>
    import HeaderNavs from '../HeaderNavs.vue';

    export default {
        name: 'HeaderMenuType3',
        components: { HeaderNavs },
        props: {
            loading: { type: Boolean, default: false },
            data: { type: Object, default: () => ({}) },
        },
    };
</script>
